import { useEffect, useState } from "react";
import { fetchMakes } from "../services/api"; // <-- Import the API function

export default function useMakes() {
  const [makes, setMakes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    fetchMakes()
      .then((data) => {
        const makesArray = Array.isArray(data) ? data : [];
        // Sort alphabetically
        const sortedMakes = makesArray.sort((a, b) => a.localeCompare(b));
        setMakes(sortedMakes);
      })
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, []);

  return { makes, loading, error };
}